<template>
  <div class="bread-crumbs">
    <div
      v-if="isLoading"
      class="bread-crumbs__loader"
    >
      <v-skeleton-loader
        class="bread-crumbs__loader__text"
        type="table-cell"
      />
      <i class="arrow-icon icon-chevron-right" />
      <v-skeleton-loader
        class="bread-crumbs__loader__text"
        type="table-cell"
      />
    </div>
    <template v-else>
      <nuxt-link :to="{ name: 'home' }">
        首頁
      </nuxt-link>
      <i class="arrow-icon icon-chevron-right" />
      <template v-for="(item, index) in breadCrumbs">
        <nuxt-link
          :key="item.routeName"
          :to="{ name: item.routeName, params: item.params }"
          :class="{ 'active': activeRouteName === item.routeName }"
        >
          {{ item.label }}
        </nuxt-link>
        <i
          v-if="index < breadCrumbs.length - 1"
          :key="index"
          class="arrow-icon icon-chevron-right"
        />
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    breadCrumbs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    activeRouteName () {
      return this.$nuxt.$route.name
    }
  }
}
</script>

<style lang="scss" scoped>
.bread-crumbs {
  padding: 20px 0;
  max-width: $containerWidth;
  margin: auto;
  display: flex;
  align-items: center;
  margin: 32px auto 12px;
  &__loader {
    width: 100%;
    display: flex;
    align-items: center;
    height: 25px;
  }
  a {
    text-decoration: none;
    color: $midGrayColor;
    transition: color .3s;
    font-size: pxTorem(15px);
    line-height: pxTorem(15px);
    &.active {
      color: $mainColor;
      font-weight: bold;
    }
    &:hover {
      color: $mainColor;
    }
  }
  .arrow-icon {
    color: $midGrayColor;
    margin: 0 8px;
    font-size: pxTorem(23px);
  }
}
@media screen and (max-width: $mobileWidth) {
  .bread-crumbs {
    margin: 0 auto;
  }
}
</style>
